export function getParamFromUrlSearch<T = any>(search: string): T {
  search = search.replace(/^\?/, "");
  const paramsArray = search.split("&").map((param) => param.split("="));
  const paramsObj: any = {};

  paramsArray.forEach((param) => {
    paramsObj[param[0]] = param[1];
  });

  return paramsObj;
}
